import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as folderActions from '../../actions/folderActions';
import AddToFoldersList from './AddToFoldersList';
import Button from '../Global/Buttons/Button';
import ModalContainer from '../Global/Modals/ModalContainer';
import ModalHeader from '../Global/Modals/ModalHeader';
import ModalFooter from '../Global/Modals/ModalFooter';
import ModalBody from '../Global/Modals/ModalBody';
import ModalPadding from '../Global/Modals/ModalPadding';
import FoldersCreateModal from "./AddToFoldersCreateModal";

class AddToFolderModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeItems: [],
      expandedFolders: new Set(),
      createFolderModal: false,
      newFolderName: ``,
      newFolderParent: 0,
      createBtnLoading: false,
      addBtnLoading: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    // Load folders on initial 'Add to Folder' click
    if (this.props.modalIsOpen !== nextProps.modalIsOpen) {
      if (this.props.folders.data.length === 0) {
        this.props.actions.getMyFolders({
          contain_content: {
            object_id: this.props.contentId,
            content_type: this.props.contentType,
          }
        });
      }
    }

    // If a new folder has been created
    if (this.props.folders.data.length !== nextProps.folders.data.length) {
      const newActiveItems = [...this.state.activeItems];
      nextProps.folders.data.forEach((folder) => {
        if (folder.new) {
          newActiveItems.push(folder.id);
        }
      });

      this.setState({
        activeItems: newActiveItems,
        createBtnLoading: false,
        createFolderModal: false,
      });
    }
  }

  createNewFolderToggle = () => {
    this.setState({ createFolderModal: true });
  }

  changeFolderName = (e) => {
    const folderName = e.target.value;
    this.setState({ newFolderName: folderName });
  }

  createNewFolder = (e) => {
    e.preventDefault();
    this.setState({ createBtnLoading: true });
    this.props.actions.createFolderV2(this.state.newFolderParent, this.state.newFolderName);
  }

  toggleActiveFolder = (id) => {
    let newActiveItems = [...this.state.activeItems];
    if (newActiveItems.includes(id)) {
      newActiveItems = newActiveItems.filter(item => item !== id);
    } else {
      newActiveItems.push(id);
    }
    this.setState({ activeItems: newActiveItems });
  }

  clearActiveFolders = () => {
    this.setState({ activeItems: [] });
  }

  toggleExpandedFolders = (id) => {
    const newExpandedFolders = new Set(this.state.expandedFolders);
    if (newExpandedFolders.has(id)) {
      // collapse all child folders within the parent
      const childFolders = this.props.folders.idTree[id];
      childFolders.forEach(folder => newExpandedFolders.delete(folder));
    } else {
      newExpandedFolders.add(id);
    }
    this.setState({ expandedFolders: newExpandedFolders });
  };

  toggleNewFolderParent = (id) => {
    let newFolderParent;
    if (this.state.newFolderParent === id) {
      newFolderParent = 0;
    } else {
      newFolderParent = id;
    }
    this.setState({ newFolderParent });
  }

  addToFolder = () => {
    this.setState({ addBtnLoading: true });
    this.props.actions.addToFolder(this.state.activeItems, this.props.contentId, this.props.contentType)
      .then(() => {
        this.closeModal();
      })
      .finally(() => {
        this.setState({ addBtnLoading: false });
      });
  };

  closeModal = () => {
    this.setState({ activeItems: [], createFolderModal: false, newFolderName: ``, createBtnLoading: false, addBtnLoading: false });
    this.props.closeModal();
  }

  closeCreateFolderModal = () => {
    this.setState({ createFolderModal: false, newFolderName: `` });
  }

  setInputFocus = (input) => {
    if (input) {
      // timeout needed because of transition on modals
      setTimeout(() => {
        input.focus();
        // set cursor to end of value
        input.setSelectionRange(input.value.length, input.value.length);
      }, 50);
    }
  }

  render() {
    const { modalIsOpen, folders } = this.props;
    const {
      activeItems,
      expandedFolders,
      createFolderModal,
      newFolderName,
      createBtnLoading,
      addBtnLoading,
      newFolderParent,
    } = this.state;

    let modalContent;
    if (createFolderModal === true) {
      const nameExists = folders.data.filter(item =>
        item.type === `folder` &&
        item.parent_id === newFolderParent &&
        item.title === newFolderName,
      );
      modalContent = (
        <FoldersCreateModal
          modalIsOpen={modalIsOpen}
          onSubmitClick={this.createNewFolder}
          onBackClick={this.closeCreateFolderModal}
          onCloseClick={this.closeModal}
          onInputChange={this.changeFolderName}
          onAfterOpen={() => { this.setInputFocus(this.createInput)}}
          nameExists={nameExists.length > 0}
          inputValue={newFolderName}
          inputRef={input => this.createInput = input}
          folderLocation={this.state.newFolderParent}
          loading={createBtnLoading}
        >
          <AddToFoldersList
            folders={folders.data}
            folderClick={this.toggleNewFolderParent}
            arrowClick={this.toggleExpandedFolders}
            homeClick={this.toggleNewFolderParent}
            activeItems={[this.state.newFolderParent]}
            expandedFolders={expandedFolders}
            loading={folders.loading}
          />
        </FoldersCreateModal>
      );
    } else {
      const activeCount = activeItems.length;
      const plural = activeCount === 1 ? `folder` : `folders`;
      modalContent = (
        <ModalContainer isOpen={modalIsOpen} closeModal={this.closeModal} label="Add to Folder Modal">
          <ModalHeader title="Add 1 item to..." onCloseClick={this.closeModal} />

          <div className="modal-create-new">
            <ModalPadding><Button onClick={this.createNewFolderToggle} classes="btn--secondary" size="s">Create new folder</Button></ModalPadding>
          </div>

          <ModalBody>
            <ModalPadding>
              <div className="d-flex">
                <ul className="inline-list-new inline-list-new--s" style={{ lineHeight: 2, width: `100%` }}>
                  <li>
                    <span className="fw-bold">{activeCount} {plural} selected</span>
                  </li>
                  <li style={{ float: `right` }}>
                    <Button onClick={this.clearActiveFolders} classes="btn--s btn--tertiary" disabled={!activeCount}>Clear</Button>
                  </li>
                </ul>
              </div>
            </ModalPadding>

            <AddToFoldersList
              folders={folders.data}
              folderClick={this.toggleActiveFolder}
              arrowClick={this.toggleExpandedFolders}
              activeItems={activeItems}
              expandedFolders={expandedFolders}
              loading={folders.loading}
            />
          </ModalBody>

          <ModalFooter>
            <Button onClick={this.addToFolder} disabled={activeItems.length === 0} loading={addBtnLoading}>Add to folder</Button>
          </ModalFooter>
        </ModalContainer>
      );
    }

    return (
      <div className="add-to-folders-modal">
        {modalContent}
      </div>
    );
  }
}

AddToFolderModal.propTypes = {
  contentId: PropTypes.number,
  contentType: PropTypes.string,
  modalIsOpen: PropTypes.bool,
  closeModal: PropTypes.func,
  folders: PropTypes.object,
  actions: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  return {
    folders: state.folders,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Object.assign({}, folderActions), dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AddToFolderModal);



// WEBPACK FOOTER //
// ./library/app/components/Folders/AddToFoldersModal.js